<template>
  <div class="main-wrapper">
    <p>
      Основные контрагенты, планируемые плательщики и получатели по операциям с
      денежными средствами, находящимися на счете
    </p>
    <p>Плательщики:</p>
    <table>
      <tr>
        <td width="3%"></td>
        <td width="27%">Тип</td>
        <td width="20%">ИНН/КИО</td>
        <td width="30%">Наименование</td>
        <td width="20%">Роль в сотрудничестве</td>
      </tr>
      <tr v-for="payer in payers" :key="payer.id">
        <td>
          <span :class="validRow(payer) ? 'valid-field' : 'unvalid-field'"
            >➤</span
          >
        </td>
        <td>
          <dropdown
            style="width: 300px"
            :options="typesList"
            :selected="{ name: payer.type }"
            placeholder="Выберите тип"
            v-on:updateOption="
              onClickType(payer, $event.name);
              controlPayersRows(payers, payer);
            "
          ></dropdown>
        </td>
        <td>
          <input
            type="text"
            v-model="payer.inn"
            v-mask="'############'"
            @blur="controlPayersRows(payers, payer)"
          />
        </td>
        <td>
          <input
            type="text"
            v-model="payer.name"
            :disabled="isInnIsRequired(payer.type)"
          />
        </td>
        <td>
          <dropdown
            :options="roles"
            :selected="{
              name: payer.role,
            }"
            placeholder="Выберите роль"
            v-on:updateOption="onClickRole(payer, $event.name)"
          ></dropdown>
        </td>
      </tr>
    </table>

    <p>Получатели:</p>
    <table>
      <tr>
        <td width="3%"></td>
        <td width="27%">Тип</td>
        <td width="20%">ИНН/КИО</td>
        <td width="30%">Наименование</td>
        <td width="20%">Роль в сотрудничестве</td>
      </tr>
      <tr v-for="recipient in recipients" :key="recipient.id">
        <td>
          <span :class="validRow(recipient) ? 'valid-field' : 'unvalid-field'"
            >➤</span
          >
        </td>
        <td>
          <dropdown
            style="width: 300px"
            :options="typesList"
            :selected="{ name: recipient.type }"
            v-on:updateOption="
              onClickType(recipient, $event.name);
              controlPayersRows(recipients, recipient);
            "
            placeholder="Выберите тип"
          ></dropdown>
        </td>
        <td>
          <input
            type="text"
            v-model="recipient.inn"
            v-mask="'############'"
            @blur="controlPayersRows(recipients, recipient)"
          />
        </td>
        <td>
          <input
            type="text"
            v-model="recipient.name"
            :disabled="isInnIsRequired(recipient.type)"
            :onchanged="
              recipient.type != null && recipient.type.length > 80
                ? (recipient.type = recipient.type.substr(0, 80))
                : recipient.type
            "
          />
        </td>
        <td>
          <dropdown
            :options="roles"
            :selected="{
              name: recipient.role,
            }"
            placeholder="Выберите роль"
            v-on:updateOption="onClickRole(recipient, $event.name)"
          ></dropdown>
        </td>
      </tr>
    </table>

    <p class="necessary-bold">
      <span
        :class="
          validKinds() && validAnotherKind() ? 'valid-field' : 'unvalid-field'
        "
        >➤</span
      >
      Виды договоров (контрактов), расчеты по которым будут осуществляться через
      Банк:
    </p>
    <div class="checkboxes">
      <label v-for="kind in agreementKinds" :key="kind.ID">
        <input
          type="checkbox"
          v-model="kind.CHECKED"
          @click="kind.VALUE == 'Иное' ? (otherKind = '') : otherKind"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('AGREEMENTS_KINDS') != -1
          "
        />
        {{ kind.VALUE }}
      </label>
    </div>
    <input
      type="text"
      v-model="otherKind"
      v-if="idOfOther != -1 && agreementKinds[idOfOther].CHECKED"
      :onchanged="
        otherKind != null && otherKind.length > 255
          ? (otherKind = otherKind.substr(0, 255))
          : otherKind
      "
      :disabled="
        pageInfo.DISABLED != null &&
          pageInfo.DISABLED.indexOf('AGREEMENTS_KINDS') != -1
      "
    />
  </div>
</template>

<script>
import dropdown from "vue-dropdowns";
export default {
  name: "MainCounteragents",
  props: {
    pageInfo: {},
    pageName: String,
    url: String,
  },
  components: { dropdown },
  data: () => ({
    typesList: [
      { name: "Юридическое лицо резидент" },
      { name: "Индивидуальный предприниматель" },
      { name: "Юридическое лицо нерезидент" },
      { name: "Физическое лицо резидент" },
      { name: "Физическое лицо нерезидент" },
    ],
    payers: [],
    recipients: [],
    sendData: {},
    agreementKinds: [],
    idOfOther: -1,
    selectedId: -1,
    otherKind: "",
    roles: [
      { name: "Заказчик" },
      { name: "Исполнитель" },
      { name: "Консультант" },
      { name: "Поставщик" },
      { name: "Перевозчик" },
      { name: "Подрядчик" },
      { name: "Покупатель" },
      { name: "Посредник" },
      { name: "Продавец" },
      { name: "Производитель" },
      { name: "Арендодатель" },
      { name: "Арендатор" },
      { name: "Иное" },
    ],
  }),
  methods: {
    isInnIsRequired(type) {
      return type == this.typesList[0].name || type == this.typesList[1].name;
    },
    isIndividFace(type) {
      return type == this.typesList[3].name || type == this.typesList[4].name;
    },
    validKinds() {
      var a = false;
      this.agreementKinds.forEach((item) => {
        if (item.CHECKED) a = true;
      });
      return a;
    },
    validAnotherKind() {
      return (
        !this.agreementKinds[this.idOfOther].CHECKED ||
        (this.agreementKinds[this.idOfOther].CHECKED &&
          this.otherKind.length > 0)
      );
    },
    controlPayersRows(array, item) {
      if (
        array[array.length - 1].inn.length == 10 ||
        array[array.length - 1].inn.length == 12
      )
        array.push({
          id: array.length + 1,
          inn: "",
          name: "",
        });
      if (this.isInnIsRequired(item.type) && item.inn.length < 8) {
        item.name = "";
      }
      if (item.inn.length == 10 || item.inn.length == 12) {
        if (
          this.isIndividFace(item.type) &&
          (item.name == null || item.name.length == 0)
        )
          item.name = "Физическое лицо";
        else if (this.isInnIsRequired(item.type)) this.getOrgName(item);
      }
    },
    async getOrgName(item) {
      let data = await (
        await fetch(this.url + "get_company_name_by_inn", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({ INN: item.inn }),
        })
      ).json();
      if (data.INN != item.inn) this.$alert("Ошибка соединения с сервером");
      else item.name = data.SHORT_NAME;
    },
    onClickRole(item, name) {
      item.role = name;
      this.$forceUpdate();
    },
    async onClickType(item, type) {
      item.type = type;
      this.$forceUpdate();
    },
    createListOfContragents() {
      this.sendData.POTENTIAL_COUNTERAGENTS = [];
      this.recipients.forEach((item) => {
        if (
          (!this.isInnIsRequired(item) ||
            (item.inn.length >= 10 && item.name.length > 0)) &&
          item.role != null &&
          item.role.length > 0
        ) {
          let a = {};
          a.CNT_TAXTYPE = item.type;
          a.CNT_INN = item.inn;
          a.CNT_ROLE = item.role;
          a.CNT_NAME = item.name;
          a.CNT_KIND = 1;
          this.sendData.POTENTIAL_COUNTERAGENTS.push(a);
        }
      });
      this.payers.forEach((item) => {
        if (
          (!this.isInnIsRequired(item) ||
            (item.inn.length >= 10 && item.name.length > 0)) &&
          item.role != null &&
          item.role.length > 0
        ) {
          let a = {};
          a.CNT_TAXTYPE = item.type;
          a.CNT_INN = item.inn;
          a.CNT_ROLE = item.role;
          a.CNT_NAME = item.name;
          a.CNT_KIND = 0;
          this.sendData.POTENTIAL_COUNTERAGENTS.push(a);
        }
      });
    },
    validRow(row) {
      return (
        ((!this.isInnIsRequired(row.type) ||
          (row.inn.length >= 10 && row.name.length > 0)) &&
          row.role != null &&
          row.role.length > 0 &&
          row.type != null) ||
        (row.inn.length == 0 && row.name.length == 0 && row.role == null)
      );
    },
    fillRows(data) {
      data.forEach((item) => {
        if (item.CNT_KIND == 0)
          this.payers.push({
            id: this.payers.length + 1,
            type: item.CNT_TAXTYPE,
            inn: item.CNT_INN,
            name: item.CNT_NAME,
            role: item.CNT_ROLE,
          });
        else if (item.CNT_KIND == 1)
          this.recipients.push({
            id: this.recipients.length + 1,
            type: item.CNT_TAXTYPE,
            inn: item.CNT_INN,
            name: item.CNT_NAME,
            role: item.CNT_ROLE,
          });
      });
      this.recipients.push({
        id: this.recipients.length + 1,
        inn: "",
        name: "",
      });
      this.payers.push({
        id: this.payers.length + 1,
        inn: "",
        name: "",
      });
    },
    validation() {
      var msg = "";
      this.payers.forEach((item) => {
        if (msg.length == 0 && !this.validRow(item))
          msg += "Необходимо полностью заполнить НЕПУСТЫЕ строки";
      });
      this.recipients.forEach((item) => {
        if (msg.length == 0 && !this.validRow(item))
          msg += "Необходимо полностью заполнить НЕПУСТЫЕ строки";
      });
      if (!this.validKinds())
        msg += "Выберите хотя бы один вид договора (контракта)<br>";
      if (!this.validAnotherKind()) msg += "Заполните поле 'Иное'<br>";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.createListOfContragents();
        this.sendData.AGREEMENTS_KINDS = [];
        this.sendData.ANOTHER_AGREEMENT_KING = this.otherKind;
        this.agreementKinds.forEach((item) => {
          if (item.CHECKED) this.sendData.AGREEMENTS_KINDS.push(item.ID);
        });
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;
    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    
    this.otherKind = this.pageInfo.ANOTHER_AGREEMENT_KING;
    this.agreementKinds = this.pageInfo.AGREEMENTS_KINDS;

    this.idOfOther = this.agreementKinds.length - 1;
    this.fillRows(this.pageInfo.POTENTIAL_COUNTERAGENTS);
    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}
td {
  border: 1px solid black;
  padding: 5px 7px;
}
input[type="text"] {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 100%;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
</style>
